<template>
  <v-app-bar :color="$_color" :dark="$_dark" app>
    <template v-if="!$_isMobile || !showSearch">
      <template v-if="$_isMobile">
        <dialog-btn height=45 color="green" class="botaoinferior"
        v-if='backTo && withDialog'
        titulo="Salvar Formulário"
        sair="Não"
        salvar='Confirmar'
        icon="mdi-alert-circle-outline"
        buttonIcon="mdi-arrow-left"
        @sair="$_novoFormulario()"
        @salvar="$_salvarFormulario()">
        <template #conteudo>
          <div>
            Deseja manter este formulário?
          </div>
        </template>
        </dialog-btn>
        <v-icon v-else-if="backTo" @click="$_backTo()" exact class="back-to-icon" >
          mdi-arrow-left
        </v-icon>

        <v-app-bar-nav-icon v-else @click="$_onClickNavIcon" />
      </template>

      <v-toolbar-title>
        <slot />
      </v-toolbar-title>

      <v-spacer />
    </template>

    <template v-if="searchable && (!$_isMobile || showSearch)">
      <v-btn v-if="$_isMobile" @click="$_onClickCloseSearch" icon>
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>

      <v-text-field clearable hide-details solo flat autofocus
        v-model="search"
        :placeholder="('labels.search')"
        :rounded="!$_isMobile"
        :light="!$_isMobile"
        :dense="!$_isMobile"
      />

      <v-spacer v-if="!$_isMobile" />
    </template>

    <slot name="actions" v-if="!$_isMobile || !showSearch" />

    <div>
      <v-badge dot
        v-if="searchable && ($_isMobile && !showSearch)"
        color="red"
        offset-x="16"
        offset-y="16"
        :value="!!search"
      >
        <v-btn @click="$_onClickOpenSearch" icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-badge>
    </div>

    <div>
      <v-tooltip v-if="filterable && (!$_isMobile || !showSearch)" bottom>
        <template #activator="{ attrs, on }">
          <v-badge dot
            color="red"
            offset-x="16"
            offset-y="16"
            :value="isFiltered"
          >
            <v-btn icon
              v-bind="attrs"
              v-on="on"
              @click="$_onClickFiltersBtn"
            >
              <v-icon>mdi-filter-variant</v-icon>
            </v-btn>
          </v-badge>
        </template>

        <span>Filtros</span>
      </v-tooltip>
    </div>

    <span class="mr-n3" />
  </v-app-bar>
</template>

<script>

import { ROUTE_ABASTECIMENTO, ROUTE_APONTAMENTO, ROUTE_NFE } from '@/constants/ROUTES';

import {
  ABASTECIMENTO_STORAGE, ROTA_STORAGE, NFE_STORAGE, LANCAMENTO_STORAGE, MANUTENCAO_STORAGE,
} from '@/constants/STORAGE';
import { GENERIC_QUERIES } from '@/constants/QUERY_FILTERS';

import { getQueryValue, setQueryValue } from '@/services/query-string';

import ToggleFiltersEvent from '@/events/ToggleFiltersEvent';
import ToggleNavigationDrawerEvent from '@/events/ToggleNavigationDrawerEvent';
import DialogBtn from '../../components/core/dialog-btn/Index.vue';

export default {
  name: 'LayoutDefaultAppbar',

  props: {
    DialogBtn,
    withDialog: Boolean,
    searchable: Boolean,
    filterable: Boolean,
    filters: Array,
    backTo: [String, Object, Boolean],
  },

  components: {
    DialogBtn,
  },

  data() {
    return {
      search: null,
      showSearch: false,
      isFiltered: false,
      cadastro: null,
    };
  },

  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    $_dark() {
      return !(this.$_isMobile && this.showSearch);
    },

    $_color() {
      return this.$_dark ? 'primary' : 'white';
    },
  },

  methods: {
    $_onClickNavIcon() {
      ToggleNavigationDrawerEvent.emit();
    },

    $_onClickOpenSearch() {
      this.showSearch = true;
    },

    $_onClickCloseSearch() {
      this.showSearch = false;
    },

    $_onClickFiltersBtn() {
      ToggleFiltersEvent.emit();
    },

    async $_salvarFormulario() {
      switch (this.cadastro) {
        case 'nfe':
          this.$router.replace({
            ...this.$route,
            name: ROUTE_NFE.name,
          });
          break;
        case 'abastecimento':
          this.$router.replace({
            ...this.$route,
            name: ROUTE_ABASTECIMENTO.name,
          });
          break;
        case 'atividade':
          this.$router.replace({
            ...this.$route,
            name: ROUTE_APONTAMENTO.name,
          });
          break;
        default:
          if (this.backTo && typeof this.backTo === 'object' && this.backTo.name) {
            this.$router.replace({
              ...this.$route,
              name: this.backTo.name,
            });
          } else if (typeof this.backTo === 'string') {
            this.$router.replace(this.backTo);
          } else {
            this.$router.go(-1);
          }
          break;
      }
      sessionStorage.removeItem(ROTA_STORAGE.cadastro);
    },

    async $_novoFormulario() {
      const storageName = this.cadastro.toUpperCase();

      switch (storageName) {
        case 'NFE': {
          const storageKeys = Object.keys(NFE_STORAGE);
          storageKeys.forEach((item) => {
            sessionStorage.removeItem(NFE_STORAGE[item]);
          });
          break;
        }
        case 'ABASTECIMENTO': {
          const storageKeys = Object.keys(ABASTECIMENTO_STORAGE);
          storageKeys.forEach((item) => {
            sessionStorage.removeItem(ABASTECIMENTO_STORAGE[item]);
          });
          break;
        }
        case 'ATIVIDADE': {
          sessionStorage.removeItem(LANCAMENTO_STORAGE.formulario);
          break;
        }
        case 'MANUTENCAO': {
          sessionStorage.removeItem(MANUTENCAO_STORAGE.formulario);
          sessionStorage.removeItem(MANUTENCAO_STORAGE.campoSelecao);
          sessionStorage.removeItem(MANUTENCAO_STORAGE.itemSelecionado);
          sessionStorage.removeItem('MANUTENCAO_NOVO_ITEM');
          sessionStorage.removeItem('MANUTENCAO_ITEM_EDITANDO_INDEX');
          sessionStorage.removeItem('MANUTENCAO_DIALOG_ITEM_ABERTO');
          sessionStorage.removeItem('MANUTENCAO_SNAPSHOT');
          break;
        }
        default: {
          const storageKeys = Object.keys(NFE_STORAGE);
          storageKeys.forEach((item) => {
            sessionStorage.removeItem(NFE_STORAGE[item]);
          });
          break;
        }
      }

      this.$_salvarFormulario();
    },

    async $_backTo() {
      this.retomar = false;
      if (this.backTo && typeof this.backTo === 'object' && this.backTo.name) {
        this.$router.replace({
          ...this.$route,
          name: this.backTo.name,
        });
      } else if (typeof this.backTo === 'string') {
        this.$router.replace(this.backTo);
      } else {
        this.$router.go(-1);
      }
    },

  },
  created() {
    this.cadastro = sessionStorage.getItem(ROTA_STORAGE.cadastro, '');
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.search = getQueryValue(GENERIC_QUERIES.search, null);

        if (!this.filters?.length) return;

        this.isFiltered = this.filters
          .some((filter) => getQueryValue(filter, false));
      },
    },

    search(search) {
      clearTimeout(this.$_searchTimeout);
      this.$_searchTimeout = setTimeout(() => {
        setQueryValue(GENERIC_QUERIES.search, search);
      }, 1000);
    },
  },
};
</script>

<style scoped>
  .btnleft {
    border: 1px solid red;
  }

  .back-to-icon {
    margin-right: 32px;
  }
</style>
